export const PROD = 'prod'
export const STAGE = 'stage'
export const MASTER = 'master'

export const SEGMENT_ENV_IDS = {
  [PROD]: 'AD29dLrdv7hifwMyYLhrhIkoDoLrqrwd',
  [MASTER]: 'Ka0V13tSAcLGdeBsUpklOBAYE0cMEkNm',
  [STAGE]: 'Ka0V13tSAcLGdeBsUpklOBAYE0cMEkNm',
}
